<template>
  <div class="container">
    <h4 class="is-size-6-mobile is-size-5-tablet">
      {{ $t("Sidebar.ລາຍງານຍອດສ້າງປະຈຳວັນ") }}
    </h4>
    <div class="box">
      <div class="columns is-multiline is-mobile">
        <div class="column is-12-mobile is-6-tablet is-3-desktop">
          <div class="control">
            <label class="label">{{ $t("creationSummaryReport.from_date") }}:</label>
            <date-picker
              format="DD/MM/YYYY HH:mm"
              value-type="YYYY-MM-DD HH:mm"
              type="datetime"
              v-model="start_date"
              :disabled-date="disabledAfterToday"
              :clearable="false"
              name="start_date"
              class="is-fullwidth"
            ></date-picker>
          </div>
        </div>
        <div class="column is-12-mobile is-6-tablet is-3-desktop">
          <div class="control">
            <label class="label">{{ $t("creationSummaryReport.to_date") }}:</label>
            <date-picker
              format="DD/MM/YYYY HH:mm"
              value-type="YYYY-MM-DD HH:mm"
              type="datetime"
              v-model="end_date"
              :disabled-date="disabledAfterToday"
              :clearable="false"
              name="end_date"
              class="is-fullwidth"
            ></date-picker>
          </div>
        </div>
        <div
          class="column is-12-mobile is-6-tablet is-3-desktop"
        >
          <label class="label is-invisible">{{ $t("creationSummaryReport.search") }}</label>
          <div class="buttons is-centered-mobile">
            <button
              class="button is-rounded is-fullwidth-mobile"
              @click="fetchData()"
            >
              <span class="icon">
                <i class="fal fa-search"></i>
              </span>
              <span>{{ $t("creationSummaryReport.search") }}</span>
            </button>
            <button
              class="button is-primary is-rounded is-fullwidth-mobile"
              @click="exportExcel()"
            >
              <span class="icon">
                <i class="fal fa-file-excel"></i>
              </span>
              <span>EXCEL</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-container" v-if="!loaded">
      <table class="table is-bordered is-striped is-fullwidth">
        <thead>
          <tr>
            <th rowspan="2" class="has-text-centered is-vcentered">{{ $t("dailyCreationReport.category") }}</th>
            <th colspan="3" class="has-text-centered">Express</th>
            <th colspan="3" class="has-text-centered">Logistics</th>
            <th colspan="3" class="has-text-centered">{{ $t("creationSummaryReport.total") }}</th>
          </tr>
          <tr>
            <th class="has-text-centered">{{ $t("creationSummaryReport.bills") }}</th>
            <th class="has-text-centered">{{ $t("creationSummaryReport.freight") }}</th>
            <th class="has-text-centered">{{ $t("dailyCreationReport.net_freight") }}</th>
            <th class="has-text-centered">{{ $t("creationSummaryReport.bills") }}</th>
            <th class="has-text-centered">{{ $t("creationSummaryReport.freight") }}</th>
            <th class="has-text-centered">{{ $t("dailyCreationReport.net_freight") }}</th>
            <th class="has-text-centered">{{ $t("creationSummaryReport.bills") }}</th>
            <th class="has-text-centered">{{ $t("creationSummaryReport.freight") }}</th>
            <th class="has-text-centered">{{ $t("dailyCreationReport.net_freight") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in tableRows"
            :key="row.key"
            :class="{ 'grand-total-row': row.key === 'grand_total' }"
          >
            <td>
              <strong>{{ row.label }}</strong>
            </td>
            <td class="has-text-right">
              {{ formatNumber(row.data.express.total_shipments) }}
            </td>
            <td class="has-text-right">
              {{ formatCurrency(row.data.express.total_freight) }}
            </td>
            <td class="has-text-right">
              {{ formatCurrency(row.data.express.net_freight) }}
            </td>
            <td class="has-text-right">
              {{ formatNumber(row.data.logistics.total_shipments) }}
            </td>
            <td class="has-text-right">
              {{ formatCurrency(row.data.logistics.total_freight) }}
            </td>
            <td class="has-text-right">
              {{ formatCurrency(row.data.logistics.net_freight) }}
            </td>
            <td class="has-text-right">
              <strong>{{
                formatNumber(row.data.total.total_shipments)
              }}</strong>
            </td>
            <td class="has-text-right">
              <strong>{{
                formatCurrency(row.data.total.total_freight)
              }}</strong>
            </td>
            <td class="has-text-right">
              <strong>{{ formatCurrency(row.data.total.net_freight) }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Loading v-if="loaded" />
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "@/views/Loading";
import XLSX from "xlsx";

const emptyCategory = {
  express: { total_shipments: 0, total_freight: 0, net_freight: 0 },
  logistics: { total_shipments: 0, total_freight: 0, net_freight: 0 },
  total: { total_shipments: 0, total_freight: 0, net_freight: 0 },
};

const categoryLabels = {
  within_vientiane: "dailyCreationReport.category_within_vientiane",
  from_vientiane_to_provinces:
    "dailyCreationReport.category_from_vientiane_to_provinces",
  from_provinces_to_vientiane:
    "dailyCreationReport.category_from_provinces_to_vientiane",
  between_other_provinces:
    "dailyCreationReport.category_between_other_provinces",
  grand_total: "dailyCreationReport.category_grand_total",
};

const categoryKeys = [
  "within_vientiane",
  "from_vientiane_to_provinces",
  "from_provinces_to_vientiane",
  "between_other_provinces",
  "grand_total",
];

export default {
  name: "dailyCreationReport",
  data() {
    return {
      start_date: moment(new Date()).format("YYYY-MM-DD 00:00"),
      end_date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
      loaded: true,
      reportData: null,
    };
  },
  computed: {
    tableRows() {
      if (!this.reportData) return [];
      return categoryKeys.map((key) => ({
        key,
        label: this.$t(categoryLabels[key]),
        data: this.reportData[key] || { ...emptyCategory },
      }));
    },
  },
  methods: {
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },
    fetchData() {
      this.loaded = true;
      this.$http
        .get(
          "v1/auth/users/me/dashboard/shipment-summary/daily-creation-report",
          {
            params: {
              start_date: this.start_date,
              end_date: this.end_date,
            },
          }
        )
        .then((res) => {
          this.reportData = res.data;
          this.loaded = false;
        })
        .catch((error) => {
          console.log(error);
          this.loaded = false;
        });
    },
    formatNumber(value) {
      if (value === null || value === undefined) return "0";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return "0";
      let p = Number(value).toFixed(2).split(".");
      return p[0]
        .split("")
        .reverse()
        .reduce(function (acc, val, i) {
          return val === "-" ? acc : val + (i && !(i % 3) ? "," : "") + acc;
        }, "");
    },
    exportExcel() {
      if (!this.reportData) return;
      const rows = categoryKeys.map((key) => {
        const cat = this.reportData[key] || { ...emptyCategory };
        return {
          [this.$t("dailyCreationReport.category")]: this.$t(
            categoryLabels[key]
          ),
          [this.$t("dailyCreationReport.excel_express_bills")]:
            cat.express.total_shipments,
          [this.$t("dailyCreationReport.excel_express_freight")]:
            cat.express.total_freight,
          [this.$t("dailyCreationReport.excel_express_net_freight")]:
            cat.express.net_freight,
          [this.$t("dailyCreationReport.excel_logistics_bills")]:
            cat.logistics.total_shipments,
          [this.$t("dailyCreationReport.excel_logistics_freight")]:
            cat.logistics.total_freight,
          [this.$t("dailyCreationReport.excel_logistics_net_freight")]:
            cat.logistics.net_freight,
          [this.$t("dailyCreationReport.excel_total_bills")]:
            cat.total.total_shipments,
          [this.$t("dailyCreationReport.excel_total_freight")]:
            cat.total.total_freight,
          [this.$t("dailyCreationReport.excel_total_net_freight")]:
            cat.total.net_freight,
        };
      });
      const dataWS = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS, "Daily Creation Report");
      XLSX.writeFile(
        wb,
        this.$t("dailyCreationReport.excel_file_name", {
          start: moment(this.start_date).format("DD-MM-YYYY"),
          end: moment(this.end_date).format("DD-MM-YYYY"),
        })
      );
    },
  },
  mounted() {
    this.fetchData();
  },
  components: {
    DatePicker,
    Loading,
  },
};
</script>

<style scoped lang="scss">
.table-container {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 10px 0;
}

.table {
  th,
  td {
    white-space: nowrap;
    font-size: 0.9rem;
    padding: 0.5em 0.75em;
  }

  thead th {
    background-color: #f5f5f5;
    position: sticky;
    top: 0;
  }
}

.grand-total-row {
  background-color: #fafafa;
  td {
    font-weight: bold;
    border-top: 2px solid #363636;
  }
}

.box {
  @media (max-width: 768px) {
    padding: 1rem;
  }
}

.buttons {
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;

    .button {
      margin-bottom: 0.5rem;
      width: 100%;
    }
  }

  @media (min-width: 769px) {
    .button {
      margin-right: 0.5rem;
    }
  }
}

::v-deep .mx-datepicker {
  width: 100%;

  .mx-input {
    width: 100%;
  }
}
</style>
